export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-torso-business-94bc22572059801d32a01304c34e8ac5.svg";